import { IDataKeys } from 'k8s/datakeys.model'
import Action from 'core/actions/Action'
import store from 'app/store'
import { cacheActions } from 'core/caching/cacheReducers'

const { dispatch } = store

class DeleteAction<
  D extends keyof IDataKeys,
  P extends Record<string, unknown> = Record<string, unknown>,
  R = void
> extends Action<D, P, R> {
  public get name() {
    return 'delete'
  }

  protected async preProcess(params: P): Promise<void> {
    const { cacheKey, addCacheKey } = this.config
    dispatch(cacheActions.setUpdating({ cacheKey, updating: true }))
    if (addCacheKey) {
      dispatch(cacheActions.setUpdating({ cacheKey: addCacheKey, updating: true }))
    }
  }

  protected postProcess = (result, params: P) => {
    // Note: result is void for delete operations, but we still need to update cache
    const { cacheKey, addCacheKey, uniqueIdentifier } = this.config

    dispatch(
      cacheActions.removeItem({
        uniqueIdentifier,
        cacheKey,
        params,
      }),
    )
    dispatch(cacheActions.setUpdating({ cacheKey, updating: false }))
    if (addCacheKey) {
      dispatch(
        cacheActions.removeItem({
          uniqueIdentifier,
          cacheKey: addCacheKey,
          params,
        }),
      )
      dispatch(cacheActions.setUpdating({ cacheKey: addCacheKey, updating: false }))
    }
  }

  protected handleError(err, params: P, options) {
    const { cacheKey, addCacheKey } = this.config
    // Without this, if an error occurs loading can be stuck as true
    dispatch(cacheActions.setUpdating({ cacheKey, updating: false }))
    if (addCacheKey) {
      dispatch(cacheActions.setUpdating({ cacheKey: addCacheKey, updating: false }))
    }
    return super.handleError(err, params, options)
  }
}

export default DeleteAction
